import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ValidatorPatterns } from '@shared/validatorpatterns';
import { IMesUser } from '../mesuser.service';
import { objectValidator, ObjectValidators, ValidatorMap } from './objectValidator';

@Injectable({ providedIn: 'root' })
export class MesEmployeeValidationService {
	constructor(private translator: TranslateService) {}

	validators(ValidateId: boolean = true): ValidatorMap<IMesUser> {
		const validator: ValidatorMap<IMesUser> = {
			id: [ObjectValidators.required],
			alias: [ObjectValidators.required, ObjectValidators.maxLength(255), ObjectValidators.pattern(ValidatorPatterns.Alias, 'mes.administration.users.dialog.alias.error.pattern'), ObjectValidators.pattern(ValidatorPatterns.NoStartOrEndWhitespacePattern, 'mes.administration.users.dialog.alias.error.pattern')],
			firstName: [ObjectValidators.required, ObjectValidators.maxLength(255), ObjectValidators.pattern(ValidatorPatterns.Description, 'mes.administration.users.dialog.firstname.error.pattern')],
			lastName: [ObjectValidators.required, ObjectValidators.maxLength(255), ObjectValidators.pattern(ValidatorPatterns.Description, 'mes.administration.users.dialog.lastname.error.pattern')],
			isActive: [ObjectValidators.required],
			salaryCode: [ObjectValidators.required],
			teamProfileId: [ObjectValidators.required],
			departmentId: [ObjectValidators.required],
			firstWorkDate: [],
		};

		if (!ValidateId) {
			delete validator.id;
		}

		return validator;
	}

	validateUser(user: IMesUser, ValidateId: boolean = true): Record<string, ValidationErrors> {
		return objectValidator.validateObject(user, this.validators(ValidateId), this.translator);
	}
}
